export default __webpack_public_path__ + "static/media/bronze-medal.91bdc522.png";